export const productsApi = "/api/products";
export const categoriesApi = "/api/categories";
export const signupPostApi = "/api/auth/signup";
export const loginPostApi = "/api/auth/login";
export const wishlistApi = "/api/user/wishlist";
export const cartApi = "/api/user/cart";
export const addressApi = "/api/user/address";
export const ordersApi = "/api/user/orders";

export const concatedApi = (...args) => args.join("/");
